<div class="container mx-auto mt-5 px-4">
  <h2 class="text-3xl font-semibold text-center mb-6">
    Detalle de la Institución Educativa
  </h2>
  <form
    [formGroup]="institucionForm"
    (ngSubmit)="actualizarInstitucion()"
    class="space-y-6"
  >
    <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
      <div class="form-group" *ngFor="let field of fieldOrder">
        <!-- Estilo especial para el campo "clave" -->
        <ng-container *ngIf="field === 'clave'; else normalField">
          <label for="clave" class="block font-semibold mb-1">Clave</label>
          <div class="relative">
            <input
              id="clave"
              [type]="showPassword ? 'text' : 'password'"
              formControlName="clave"
              class="border border-gray-300 rounded w-full py-2 px-4 pr-10"
              placeholder="Ingresar clave nueva"
              [readonly]="!isEditable"
            />
            <button
              type="button"
              class="absolute inset-y-0 right-0 px-3 py-2"
              (click)="togglePasswordVisibility()"
            >
              <i [class]="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
            </button>
          </div>
          <small class="text-red-400"
            >* Solo use este campo si quiere cambiar la clave a uno nuevo</small
          >
        </ng-container>

        <!-- Estilo normal para otros campos -->
        <ng-template #normalField>
          <label [for]="field" class="block text-lg font-medium"
            >{{ formatLabel(field) }} *</label
          >
          <input
            [id]="field"
            type="text"
            [formControlName]="field"
            class="w-full px-4 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            [readonly]="!isEditable"
          />
          <small
            *ngIf="
              institucionForm.controls[field].touched &&
              institucionForm.controls[field].invalid
            "
            class="text-red-500"
          >
            Este campo es obligatorio.
          </small>
        </ng-template>
      </div>
    </div>

    <!-- Botones -->
    <div class="flex justify-between mt-6">
      <button
        type="button"
        class="bg-gray-500 text-white px-6 py-2 rounded-lg shadow hover:bg-gray-600"
        (click)="volver()"
      >
        Volver
      </button>
      <div>
        <button
          type="button"
          class="bg-blue-500 text-white px-6 py-2 rounded-lg shadow hover:bg-blue-600"
          (click)="habilitarEdicion()"
          *ngIf="!isEditable"
        >
          Editar
        </button>
        <button
          type="submit"
          class="bg-green-500 text-white px-6 py-2 rounded-lg shadow hover:bg-green-600"
          *ngIf="isEditable"
        >
          Guardar
        </button>
      </div>
    </div>
  </form>
</div>
